module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Yummy","short_name":"Yummy","start_url":"/","background_color":"#ec973b","theme_color":"#ec973b","display":"standalone","icon":"src/components/layout/assets/android-chrome-192x192.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ded9d37a62f5e53909c4386e6f97edaf"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
